import React from "react"
import { useNavigate, useParams } from "react-router-dom"
import DashboardCard from "../../DashboardComponents/DashboardCard"
import { AvatarGroup } from "../../DashboardComponents/AvatarGroup"
import CustomButton from "../../OnboardingComponents/CustomButton"
import EmptyState from "../../Common/EmptyState"
import TruncatedText from "../../Common/TruncatedText"
import { ICONS } from "../../../constants/icons"
import { getSessionVisibilityClassKey } from "../../../helpers/sessionDetail"
import { useSelector } from "react-redux"
const sessionTypeIcon = (type = "") => {
  const normalized = type.toLowerCase()
  if (normalized.includes("solo")) {
    return ICONS.soloSession
  }
  return ICONS.session
}

/**
 * SessionsLogCard — recent session table for Current (in-progress).
 * Keeps a horizontal-scroll table on all breakpoints (no card stack).
 */
const SessionsLogCard = ({ sessions = [], fullHeight = true }) => {
  const navigate = useNavigate()
  const { projectId } = useParams()
  const currentUserType = useSelector(state => state.auth?.currentUser?.type)

  const redirectLink = currentUserType === "member" ? `/projects/${projectId}/sessions` : `/admin/projects/${projectId}/sessions`

  return (
    <DashboardCard
      title="Recent Sessions Logs"
      tone="neutral"
      className="dcard--no-spacing dcard--no-justify dashboard__projects-card"
      fullHeight={fullHeight}
      topRight={
        sessions.length > 0 ? (
          <CustomButton
            variant="primary"
            size="sm"
            type="button"
            trailingIconSrc={ICONS.arrowRight}
            trailingIconAlt=""
            onClick={() => projectId && navigate(redirectLink)}
          >
            View All
          </CustomButton>
        ) : null
      }
    >
      {sessions.length === 0 ? (
        <EmptyState
          title="No sessions found"
          description="There are no sessions for this project yet."
        />
      ) : (
        <div className="projects-listing__table-wrapper project-overview__sessions-wrap">
          <div
            className="projects-listing__table project-overview__sessions-table"
            role="table"
            aria-label="Recent Sessions Logs"
          >
            <div
              className="projects-listing__table-row projects-listing__table-row--head project-overview__sessions-row"
              role="row"
            >
              <div role="columnheader">Session Type</div>
              <div role="columnheader">Visibility</div>
              <div role="columnheader">Working Note</div>
              <div role="columnheader">Collaborators</div>
              <div role="columnheader">Logged Hours</div>
              <div role="columnheader">Session End At</div>
            </div>

            {sessions.map(session => (
              <div
                key={session.id}
                className="projects-listing__table-row project-overview__sessions-row"
                role="row"
              >
                <div className="projects-listing__table-cell" role="cell">
                  <span className="project-overview__session-type">
                    <img
                      src={sessionTypeIcon(session.type)}
                      alt=""
                      className="project-overview__session-icon"
                      width={16}
                      height={16}
                    />
                    <TruncatedText className="projects-listing__table-title">
                      {session.type}
                    </TruncatedText>
                  </span>
                </div>
                <div className="projects-listing__table-cell" role="cell">
                  {session.visibility && session.visibility !== "---" ? (
                    <span
                      className={`project-overview__visibility project-overview__visibility--${getSessionVisibilityClassKey(
                        session.visibility,
                      )}`}
                    >
                      {session.visibility}
                    </span>
                  ) : (
                    <span className="project-overview__visibility">---</span>
                  )}
                </div>
                <div className="projects-listing__table-cell" role="cell">
                  <TruncatedText>{session.note}</TruncatedText>
                </div>
                <div className="projects-listing__table-cell" role="cell">
                  <AvatarGroup
                    people={session.collaborators}
                    size="xs"
                    max={3}
                  />
                </div>
                <div className="projects-listing__table-cell" role="cell">
                  <TruncatedText>{session.logged}</TruncatedText>
                </div>
                <div className="projects-listing__table-cell" role="cell">
                  <TruncatedText>{session.endAt}</TruncatedText>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </DashboardCard>
  )
}

export default SessionsLogCard
